module.exports = __webpack_public_path__ + "img/fretado.a6947ac4.svg";